import { Component, OnInit, Input, Inject, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ReportStandardViewModel } from '../../model/models';
import { ReportStandardDetailsComponent } from '../report-standard-details/report-standard-details.component';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, race, of } from 'rxjs';
import { AlertService } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-report-standard-list',
    templateUrl: './report-standard-list.component.html',
    styleUrls: ['./report-standard-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportStandardListComponent implements OnInit {

    @Input() reportStandardGroupId: number;
    @Input() reportStandards: ReportStandardViewModel[];
    @Input() reportIsDirty: boolean = false;
    @Input() dirtyMessage: string;
    @Input() hasPermissionToChange$: Observable<boolean>;
    @Output() refreshRequest: EventEmitter<number> = new EventEmitter();

    constructor(
        public dialog: MatDialog,
        private alertService: AlertService,
        private translationService: AppTranslationService,
        private snackBar: MatSnackBar

        ) { }

  ngOnInit() {
  }

  public showDetails(event: Event, reportStandard: ReportStandardViewModel): void {
      this.okToOpenDialog().subscribe((ok) => {
          if (ok) {
              let config = new MatDialogConfig();
              config.data = {
                  reportStandardId: reportStandard.reportStandardId,
                  reportStandardName: reportStandard.name,
                  reportId: reportStandard.reportId,
                  hasPermissionToChange$: this.hasPermissionToChange$
              };
              config.minWidth = 500;
              config.disableClose = true;
              event.stopPropagation();

              let dialogRef = this.dialog.open(ReportStandardDetailsComponent, config);
              dialogRef.afterClosed().subscribe(result => {
                  if (result) {
                      this.refreshRequest.emit(this.reportStandardGroupId);
                  }
              });
          }
      });
  }

  // Prevent opening of child dialogs if the form is dirty
  okToOpenDialog(): Observable<boolean> {
      this.alertService.resetStickyMessage();

      if (this.reportIsDirty) {
          let snackbar = this.snackBar.open(this.dirtyMessage,
              this.translationService.getTranslation("commands.OK"),
              { duration: 5000 });
          
          let close = snackbar.onAction().pipe(map(() => { return true; }));
          let remain = snackbar.afterDismissed().pipe(map(() => { return false; }));

          return race(close, remain);
      } else {
          return of(true);
      }
  }

  getFulfillText(value: any): string {
        switch (value) {
            case -1:
                return "Ej tillämplig";
            case 0:
                return "Ej uppfylld";
            case 1:
                return "Uppfylld";
            default:
                return "";
        }
    }
}
